import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "./about.css";

const About = () => {
  const teamData = [
    {
      name: "Manimaran G",
      role: "Nodal Officer",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434205/nodal_loo2hm.png",
      color: "from-amber-400 to-orange-500"
    }
  ];

  const leadership = [
    {
      name: "Sugeshan S",
      role: "Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792646254/copy_of_829e0ef6-c28e-4125-8037-7885c70686af_kvh1wt.png",
      color: "from-violet-400 to-purple-600"
    },
    {
      name: "Shri Sai Mathurya",
      role: "Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792569843/Elegant_Portrait_in_Plum_Attire_iuhrix.png",
      color: "from-cyan-400 to-cyan-600"
    },
    {
      name: "Lakshith Anand",
      role: "Entrepreneurship - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792572486/743a3bb2-3a29-4c53-9016-ac5bd666f581_ana4u4.png",
      color: "from-cyan-400 to-cyan-600"
    },
    {
      name: "Kanishkar M",
      role: "Entrepreneurship - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792573060/8832e57c-37b2-41fd-873d-98a07f54ffc5_z865uw.png",
      color: "from-cyan-400 to-cyan-600"
    },
    {
      name: "Arshiya M",
      role: "Masoom - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792640006/1e122cbc-5b23-45ad-b7d1-2e0088f2306f_mjhq2p.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Arputha B",
      role: "Masoom - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792573456/6dba5dd5-f764-4b06-bab6-9f8e12709b46_pvvkmq.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Nithyasree S",
      role: "Accessibility - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434197/nithya_fx453g.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Sujith A",
      role: "Accessibility - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792573758/31e33fa5-ec40-4bb8-9659-6eb40aa1f511_dcn644.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Sarankumar V",
      role: "Learning - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792573951/1103829d-b899-4df3-b75e-2e83649dfa37_srgu0d.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Harini V K",
      role: "Learning - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792574097/3d105825-39a3-4b31-824e-1910c9998f44_y5ssof.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Kawin K",
      role: "Health - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792574263/54c3dca5-3980-4939-a496-3d2ad013c5fd_upwffj.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Natchathira V D",
      role: "Health - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792574510/cd949ded-84e1-4ddf-9660-b01153605e5c_qsgfxe.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "PELLETI SINDHU SRI",
      role: "Road Safety - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792638498/90ef530c-1308-48cc-a480-0d89c12c5bf5_hw178n.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Charan B",
      role: "Road Safety - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792650743/02c1e923-1518-4e9c-875d-12dd99c77695_acrtvv.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Vishnu Priya A K",
      role: "Innovation - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792638831/bb3ec056-0f57-4c64-9111-e3fa15bb36c0_qa6bd2.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Renita Ireen G",
      role: "Innovation - Co-Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792639508/1922deab-1833-4313-bd7c-796e407a9724_fu8isp.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Esakindar A",
      role: "Sports - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434188/esakindhar_bijzvb.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Janani",
      role: "Sports - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792639931/465d2523-87f3-400a-8d2f-44cac8a2daf9_rgdsok.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Muzammil Sahul",
      role: "Branding - Chair",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792648789/841eff9c-930d-49e2-ba16-bbe3c5fecc91_hcnri8.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Sujith Mano M",
      role: "Head of Operations",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792649309/file_00000000c6d08211a6c0f1968e1034fb_zonyl4.png",
      color: "from-pink-400 to-pink-600"
    }
  ];

  const techTeam = [
    {
      name: "Sugeshan S",
      role: "Backend · MERN",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792646254/copy_of_829e0ef6-c28e-4125-8037-7885c70686af_kvh1wt.png",
      color: "from-blue-400 to-blue-600"
    },
    {
      name: "Arshiya M",
      role: "Frontend",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1792640006/1e122cbc-5b23-45ad-b7d1-2e0088f2306f_mjhq2p.png",
      color: "from-pink-400 to-pink-600"
    },
    {
      name: "Nithyasree S",
      role: "Frontend",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434197/nithya_fx453g.png",
      color: "from-emerald-400 to-green-600"
    },
    {
      name: "Esakindar A",
      role: "UI/UX",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434188/esakindhar_bijzvb.png",
      color: "from-orange-400 to-orange-600"
    },
    {
      name: "Keshavardhini B",
      role: "UI/UX",
      image: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434197/kesha_qx0s3u.png",
      color: "from-purple-400 to-purple-600"
    }
  ];

  const pillars = [
    {
      icon: "🚀",
      title: "Innovation Driven",
      desc: "Real-world exposure aligned with national priorities"
    },
    {
      icon: "🌍",
      title: "Pan-India Network",
      desc: "Connected to YUVA chapters across 100+ colleges"
    },
    {
      icon: "👥",
      title: "Leadership Pipeline",
      desc: "Ethical, inclusive leaders for tomorrow"
    },
    {
      icon: "💡",
      title: "Purpose-Led",
      desc: "Innovation addressing national challenges"
    }
  ];

  const empowermentPoints = [
    "Build leadership and teamwork skills",
    "Gain industry exposure and mentorship",
    "Develop innovation capabilities",
    "Engage in social impact initiatives"
  ];

  const uniquePoints = [
    { title: "Industry Integration", desc: "Direct access to Yi–CII leaders and initiatives" },
    { title: "Leadership with Purpose", desc: "Students lead projects addressing national challenges" },
    { title: "Experiential Learning", desc: "Hands-on programs and real-world engagement" },
    { title: "Pan-India Network", desc: "Connected to Yi and YUVA chapters across India" }
  ];

  const commitmentPoints = [
    "Ethical & inclusive leadership",
    "Innovation & entrepreneurship",
    "Community-driven initiatives",
    "Future-ready student leaders"
  ];

  return (
    <>
      <Navbar />

      <div className="about-page-premium">
        {/* CINEMATIC HERO SECTION */}
        <section className="premium-hero">
          <div className="hero-background" />

          <div className="hero-content">
            <div className="hero-accent" />

            <h2 className="hero-title">
              <span className="title-word">Building</span>
              <span className="title-word">India's</span>
              <span className="title-word gradient-text">Next Generation</span>
              <span className="title-word">of Innovators</span>
            </h2>

            <p className="hero-subtitle">
              Where future leaders are forged through meaningful engagement, real-world exposure, and transformative experiences aligned with the spirit of One Bharat, One Spirit.
            </p>

            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">YUVA Chapters</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">∞</div>
                <div className="stat-label">Possibilities</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">1</div>
                <div className="stat-label">Vision</div>
              </div>
            </div>
          </div>
        </section>

        {/* EDITORIAL NARRATIVE SECTION */}
        <section className="narrative-section">
          <div className="narrative-container">
            <div className="narrative-left">
              <h2 className="section-eyebrow">What We Are</h2>
              <h3 className="narrative-heading">
                An elite innovation ecosystem that transforms ambitious students into responsible leaders
              </h3>
            </div>

            <div className="narrative-right">
              <p className="narrative-body">
                YUVA is the student-centric vertical of Young Indians (Yi), part of the Confederation of Indian Industry (CII). We're not just a club—we're a movement to empower the next generation to lead with purpose, innovate with intention, and build with impact.
              </p>
              <p className="narrative-body">
                At Saveetha Engineering College, our chapter bridges industry, academia, and society, creating pathways for real-world exposure and meaningful change.
              </p>
            </div>
          </div>
        </section>

        {/* PREMIUM PILLARS SECTION */}
        <section className="pillars-section">
          <div className="section-header">
            <h2 className="section-eyebrow">Commitment</h2>
            <h3 className="section-title">
              What makes YUVA unique
            </h3>
          </div>

          <div className="pillars-grid">
            {pillars.map((pillar, idx) => (
              <div key={idx} className="pillar-card" style={{ animationDelay: `${idx * 0.1}s` }}>
                <div className="pillar-icon">{pillar.icon}</div>
                <h4 className="pillar-title">{pillar.title}</h4>
                <p className="pillar-desc">{pillar.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* EMPOWERMENT SHOWCASE */}
        <section className="empowerment-section">
          <div className="empowerment-left">
            <h2 className="section-eyebrow">Through YUVA</h2>
            <h3 className="empowerment-title">
              Students are empowered to
            </h3>

            <div className="empowerment-list">
              {empowermentPoints.map((point, idx) => (
                <div key={idx} className="empowerment-item" style={{ animationDelay: `${idx * 0.05}s` }}>
                  <div className="empowerment-dot" />
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="empowerment-right">
            <div className="empowerment-visual">
              <div className="visual-element visual-1" />
              <div className="visual-element visual-2" />
              <div className="visual-element visual-3" />
            </div>
          </div>
        </section>

        {/* UNIQUE VALUE PROPOSITIONS */}
        <section className="unique-section">
          <div className="section-header centered">
            <h2 className="section-eyebrow">Differentiation</h2>
            <h3 className="section-title">
              Why students choose YUVA
            </h3>
          </div>

          <div className="unique-grid">
            {uniquePoints.map((point, idx) => (
              <div key={idx} className="unique-card" style={{ animationDelay: `${idx * 0.08}s` }}>
                <div className="unique-card-number">{String(idx + 1).padStart(2, '0')}</div>
                <h4 className="unique-card-title">{point.title}</h4>
                <p className="unique-card-desc">{point.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* COMMITMENT AT SAVEETHA */}
        <section className="commitment-section">
          <div className="commitment-container">
            <div className="commitment-left">
              <h2 className="section-eyebrow">Our Focus</h2>
              <h3 className="commitment-title">
                Our commitment at Saveetha Engineering College
              </h3>

              <div className="commitment-pillars">
                {commitmentPoints.map((point, idx) => (
                  <div key={idx} className="commitment-pill" style={{ animationDelay: `${idx * 0.06}s` }}>
                    <div className="pill-check">✓</div>
                    <span>{point}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="commitment-right">
              <div className="commitment-visual" />
            </div>
          </div>
        </section>

        {/* NODAL OFFICER SECTION */}
        <section className="leadership-section nodal-section">
          <div className="section-header">
            <h2 className="section-eyebrow">Leadership</h2>
            <h3 className="section-title">Nodal Officer</h3>
          </div>

          <div className="nodal-showcase">
            {teamData.map((member, idx) => (
              <div key={idx} className="premium-team-card nodal-card">
                <div className="team-image-wrapper">
                  <div className={`team-image-frame bg-gradient-to-br ${member.color}`}>
                    <img src={member.image} alt={member.name} className="team-image" />
                  </div>
                  <div className="frame-glow" />
                </div>
                <div className="team-info">
                  <h4 className="team-name">{member.name}</h4>
                  <p className="team-role">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* LEADERSHIP TEAM SECTION */}
        <section className="leadership-section">
          <div className="section-header">
            <h2 className="section-eyebrow">Visionaries</h2>
            <h3 className="section-title">Leadership Team</h3>
          </div>

          <div className="leadership-showcase">
            {leadership.map((member, idx) => (
              <div key={idx} className="premium-team-card leadership-card" style={{ animationDelay: `${idx * 0.1}s` }}>
                <div className="team-image-wrapper">
                  <div className={`team-image-frame bg-gradient-to-br ${member.color}`}>
                    <img src={member.image} alt={member.name} className="team-image" />
                  </div>
                  <div className="frame-glow" />
                </div>
                <div className="team-info">
                  <h4 className="team-name">{member.name}</h4>
                  <p className="team-role">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* BRANDING & TECH TEAM SECTION */}
        <section className="tech-team-section">
          <div className="section-header">
            <h2 className="section-eyebrow">Architects</h2>
            <h3 className="section-title">Tech Team</h3>
          </div>

          <div className="tech-team-grid">
            {techTeam.map((member, idx) => (
              <div key={idx} className="premium-team-card tech-card" style={{ animationDelay: `${idx * 0.05}s` }}>
                <div className="team-image-wrapper">
                  <div className={`team-image-frame bg-gradient-to-br ${member.color}`}>
                    <img src={member.image} alt={member.name} className="team-image" />
                  </div>
                  <div className="frame-glow" />
                </div>
                <div className="team-info">
                  <h4 className="team-name">{member.name}</h4>
                  <p className="team-role">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="cta-section">
          <div className="cta-container">
            <h2 className="cta-title">
              Ready to be part of the revolution?
            </h2>
            <p className="cta-subtitle">
              Join YUVA and become a builder of tomorrow's India
            </p>
            <Link to="/membership" className="cta-button">
              Join YUVA Today
              <span className="button-arrow">→</span>
            </Link>
          </div>
        </section>

      </div>

      <Footer />
    </>
  );
};

export default About;
